export default "__VITE_ASSET__d20336ce__"